import { Slide } from '@features/powerpoint';
import { lciAdaptiveSyntheticControlSlide as baseSlide } from '@features/lci-report/slides/appendix/lci-adaptive-synthetic-control/slide';

export const lciAdaptiveSyntheticControlSlide = (): Slide => {
  return baseSlide({
    firstStepText:
      'Algorithm is seeded with historic visitation data, with ML modeled weighting within brand and category.',
  });
};
